<!--
     <ProcessDependingUserField
       :props="my_attrs_dictionary"
       @bind="my_bind_handler"
     />

     Public propertys:
       value → Gives the field's serializable value

     Accepted props:
     - id [REQUIRED] → This instance id.
     - process_field_id [REQUIRED] → The id of a process select to watch
     - permission_id [REQUIRED] → The permission_id, like "NCDEFAULT.evaluador"
     - multiple (default: false)
     - value
     - label
     - placeholder
-->

<template>
  <component
    v-bind:is="props.subcomponent"
    :ref="props.subcomponent_props.id"
    :id="props.subcomponent_props.id"
    :props="props.subcomponent_props"
    ></component>
</template>


<script>
import { mapGetters } from 'vuex'

import TextInput from '@/components/inputs/TextInput'
import DateInput from '@/components/inputs/DateInput'
import TextareaInput from '@/components/inputs/TextareaInput'
import NumericInput from '@/components/inputs/NumericInput'

export default {
  components: {
    TextInput,
    DateInput,
    TextareaInput,
    NumericInput,    
  },
  name: 'ComputedInput',

  props: ['props'],

  data: () => ({
    loading: false,
    root_field_id: '',
  }),

  computed: {
    ...mapGetters(['sitePath']),

    value() {
      return null
    },
  },

  methods: {
    validate() {
      // TODO: Show error message
      return true
    },

    error_state(ok) {
      this.valid = ok
    }
  },
}
</script>
<style lang="scss">
@import '@/sass/modalform.scss';
</style>
